import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import type { ReduxState } from 'app/redux/types';

import type { RecordOfUnionsState } from 'app/lib/betting/betting-entities';
import { SportId } from 'app/lib/betting/constants';
import { getSportKey } from 'app/lib/betting/sport-utils';
import { GridHeader } from 'app/modules/Betting';

import { onlyLiveMatches, selectSomeLiveMatch } from '../selectors';
import { getUnionsFromSportsSelector, sports } from '../selectors/entities';
import Union from './Union';

import styles from '../InterestingMatches.module.scss';

// ---

type StoreProps = {
  sportName: string;
  tournamentUnions: RecordOfUnionsState['byId'];
  someLiveMatch: ReturnType<typeof selectSomeLiveMatch>;
  onlyLiveMatches: boolean;
};

type InterestingMatchesSportProps = {
  sportId: SportId;
};

const InterestingMatchesSport: FC<InterestingMatchesSportProps & StoreProps> = ({
  sportId,
  sportName,
  tournamentUnions,
  onlyLiveMatches,
  someLiveMatch,
}) => {
  if (onlyLiveMatches && !someLiveMatch) {
    return null;
  }

  return (
    <>
      <GridHeader sportId={sportId}
                  eventName={sportName}
                  columnsHeaderClassName={styles.filters}
                  className={classNames(
                    styles[getSportKey(sportId)],
                    styles.header,
                  )} />

      {tournamentUnions.toList().map((tournamentUnion) => (
        <Union tournamentUnionId={tournamentUnion.id}
               key={tournamentUnion.id} />
      ))}
    </>
  );
};

const mapStateToProps = (
  state: ReduxState,
  { sportId }: InterestingMatchesSportProps,
): StoreProps => ({
  sportName: sports(state).get(sportId)?.name || '',
  tournamentUnions: getUnionsFromSportsSelector(state, sportId),
  someLiveMatch: selectSomeLiveMatch(state, sportId),
  onlyLiveMatches: onlyLiveMatches(state),
});

export default connect(mapStateToProps)(InterestingMatchesSport);
